module.exports = __webpack_public_path__ + "static/ANALYSIS-ac07140551b881419ff6103d65df3266.png";